import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4ZM20 4V17.17L18.83 16H4V4H20ZM6 12H18V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.93506 3.50006C1.93506 2.63573 2.63573 1.93506 3.50006 1.93506H12.5001C13.3644 1.93506 14.0651 2.63573 14.0651 3.50006V13.0172C14.0651 13.6988 13.241 14.0401 12.7591 13.5582L10.3934 11.1925C10.3119 11.1109 10.2012 11.0651 10.0858 11.0651H3.50006C2.63573 11.0651 1.93506 10.3644 1.93506 9.50006V3.50006ZM3.50006 3.06506C3.25981 3.06506 3.06506 3.25981 3.06506 3.50006V9.50006C3.06506 9.7403 3.25981 9.93506 3.50006 9.93506H10.0858C10.5009 9.93506 10.899 10.0999 11.1925 10.3934L12.9351 12.136V3.50006C12.9351 3.25981 12.7403 3.06506 12.5001 3.06506H3.50006ZM4.93506 5.50006C4.93506 5.18802 5.18802 4.93506 5.50006 4.93506H10.5001C10.8121 4.93506 11.0651 5.18802 11.0651 5.50006C11.0651 5.8121 10.8121 6.06506 10.5001 6.06506H5.50006C5.18802 6.06506 4.93506 5.8121 4.93506 5.50006ZM5.50006 6.93506C5.18802 6.93506 4.93506 7.18802 4.93506 7.50006C4.93506 7.8121 5.18802 8.06506 5.50006 8.06506H10.5001C10.8121 8.06506 11.0651 7.8121 11.0651 7.50006C11.0651 7.18802 10.8121 6.93506 10.5001 6.93506H5.50006Z"
  />
);

export const CommentOutlineIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="CommentOutline" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
